// theme-sources/js/core-ui/components/lang-switcher.js

import { sectionLogger } from "./_logger";

const DEBUG = true;
const logger = sectionLogger("LangSwitcher", DEBUG);

class LangSwitcher extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".lang-switcher__current");
    this.items = this.querySelectorAll("[data-lang]");
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    if (!this.button) return;

    this.button.addEventListener("click", () => {
      const isOpen = this.classList.toggle("open");
      this.button.setAttribute("aria-expanded", isOpen);
    });

    this.items.forEach((item) => {
      item.addEventListener("click", () => {
        this.switchLanguage(item);
      });
    });

    document.addEventListener("click", this.handleOutsideClick);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleOutsideClick);
  }

  handleOutsideClick(e) {
    if (!this.contains(e.target)) {
      this.classList.remove("open");
      this.button.setAttribute("aria-expanded", "false");
    }
  }

  stripLangPrefix(path) {
    /*if (path.startsWith("/en")) return path.replace("/en", "") || "/";
    if (path.startsWith("/de-de")) return path.replace("/de-de", "") || "/";
    return path || "/";*/
    return path.replace(/^\/(en|de-de)(?=\/|$)/, "");
  }

  switchLanguage(item) {
    const path = window.location.pathname;
    const basePath = this.stripLangPrefix(path) || "/";
    const prefix = item.dataset.path;

    const newPath = (prefix === "/" ? basePath : prefix + basePath).replace(
      /\/{2,}/g,
      "/",
    );
    window.location.href = newPath;
  }
}

if (!customElements.get("lang-switcher")) {
  customElements.define("lang-switcher", LangSwitcher);
}
